var _line, _rect, _rect2, _line2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoriesPoly(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 91,
    viewBox: "0 0 110 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 0.114075,
    x2: 0.500001,
    y2: 28.1141,
    stroke: "black",
    strokeDasharray: "1 6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.17358,
    y: 86.4257,
    width: 5.11863,
    height: 5.11863,
    transform: "rotate(135 8.17358 86.4257)",
    fill: "#F7F0F0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 97.8276,
    y: 2.47089,
    width: 3.49435,
    height: 3.49435,
    transform: "rotate(135 97.8276 2.47089)",
    fill: "#F7F0F0"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 109.5,
    y1: 64.1141,
    x2: 109.5,
    y2: 90.1141,
    stroke: "black",
    strokeDasharray: "1 6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.5788 18.1618C89.0051 18.3824 91.8576 20.2791 91.8576 26.1017V46.6128V70.7631H42.8164V57.6955V40.6141H24.714C21.5329 40.6141 19 34.7732 19 30.1141C19 25.455 21.5329 20.1468 24.714 20.1468H34.6422C35.1036 18.6233 36.9493 17.9163 38.5377 18.1618H87.5788Z",
    fill: "#EADDDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5377 18.1618H87.5788C89.0051 18.3824 91.8576 20.2791 91.8576 26.1017C91.8576 29.086 91.8576 37.4702 91.8576 46.6128M38.5377 18.1618C39.2728 18.2755 40.3868 18.8345 41.2938 20.1468M38.5377 18.1618C36.9493 17.9163 35.1036 18.6233 34.6422 20.1468M41.2938 20.1468C42.1466 21.3806 42.8164 23.2802 42.8164 26.1017V40.6141M41.2938 20.1468H24.714C21.5329 20.1468 19 25.455 19 30.1141C19 34.7732 21.5329 40.6141 24.714 40.6141H42.8164M42.8164 40.6141V57.6955M42.8164 57.6955V70.7631H91.8576C91.8576 64.6889 91.8576 55.3079 91.8576 46.6128M42.8164 57.6955L52.5259 47.6053L57.4629 52.7331L70.2992 39.8309M91.8576 46.6128L84.7812 39.5001M70.2992 39.8309L77.7048 32.3873L84.7812 39.5001M70.2992 39.8309L75.2362 44.7933L78.6922 41.3196L80.8315 43.47L84.7812 39.5001M46.1078 61.3346H55.3236M57.4629 61.3346H88.4017",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8 30.1141C27.8 33.4711 26.3225 36.1925 24.5 36.1925C22.6775 36.1925 21.2 33.4711 21.2 30.1141C21.2 26.7571 22.6775 24.0356 24.5 24.0356C26.3225 24.0356 27.8 26.7571 27.8 30.1141Z",
    fill: "#EADDDD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 30.1141C30 35.6369 27.5376 40.1141 24.5 40.1141C21.4624 40.1141 19 35.6369 19 30.1141C19 24.5912 21.4624 20.1141 24.5 20.1141C27.5376 20.1141 30 24.5912 30 30.1141Z",
    fill: "#EADDDD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8 30.1141C27.8 33.4711 26.3225 36.1925 24.5 36.1925C22.6775 36.1925 21.2 33.4711 21.2 30.1141C21.2 26.7571 22.6775 24.0356 24.5 24.0356C26.3225 24.0356 27.8 26.7571 27.8 30.1141Z",
    stroke: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30 30.1141C30 35.6369 27.5376 40.1141 24.5 40.1141C21.4624 40.1141 19 35.6369 19 30.1141C19 24.5912 21.4624 20.1141 24.5 20.1141C27.5376 20.1141 30 24.5912 30 30.1141Z",
    stroke: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7542 36.5226C60.7542 39.3546 58.4702 41.6504 55.6526 41.6504C52.8351 41.6504 50.551 39.3546 50.551 36.5226C50.551 33.6906 52.8351 31.3948 55.6526 31.3948C58.4702 31.3948 60.7542 33.6906 60.7542 36.5226Z",
    fill: "#EADDDD",
    stroke: "#EA5A5A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8164 57.6945L52.5259 47.6043L57.4629 52.7321L70.2992 39.8299M91.8576 46.6118L84.7812 39.4991M70.2992 39.8299L77.7047 32.3864L84.7812 39.4991M70.2992 39.8299L75.2362 44.7923L78.6922 41.3186L80.8315 43.469L84.7812 39.4991M46.1078 61.3336H56H88.4016",
    stroke: "#333333"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8164 70.7606V57.693V37.0164",
    stroke: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9999 70.7606L91.8425 57.693V37.0164",
    stroke: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22 50.7836C22 48.4107 24.4119 46.8683 25.6179 46.809H26.0472V45.8598H25.4953V44.8514V41.5887C25.4953 41.4305 25.6057 41.1141 26.0472 41.1141H30.9528C31.3943 41.1141 31.5047 41.4305 31.5047 41.5887V44.8514V45.8598H30.9528V46.809H31.3821C32.588 46.8683 35 48.4107 35 50.7836V68.2242C35 68.5209 34.767 69.1141 33.8349 69.1141H28.4387H23.1651C22.233 69.1141 22 68.5209 22 68.2242V50.7836Z",
    fill: "#EADDDD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35 53.1141H22V62.1141H35V53.1141Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 55.1141C26.9908 57.1141 24.8778 61.1141 28.5 61.1141C32.1222 61.1141 30.0092 57.1141 28.5 55.1141Z",
    fill: "#EA5A5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoriesPoly);
export default __webpack_public_path__ + "static/media/categoriesPoly.49e2c318727f27ea9307bd66a95fc5ee.svg";
export { ForwardRef as ReactComponent };